export const cmxState = {
    feedback: null
};
